import { render, staticRenderFns } from "./ExperimentShowEdit.vue?vue&type=template&id=0fa0e61a&"
import script from "./ExperimentShowEdit.vue?vue&type=script&lang=js&"
export * from "./ExperimentShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentShowEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports